import clsx from 'clsx';
import {
  Close,
  KeyboardArrowDown,
  KeyboardArrowUp,
  NavigateBefore,
  NavigateNext,
} from '@material-ui/icons';
import Draggable from 'react-draggable';
import { IconButton } from '../../components/IconButton';
import { useCitrusView } from '../../contexts/CitrusViewContext';

interface Props {
  open: boolean;
  onClose(): void;
}

export const MobileNavButtons = ({ open, onClose }: Props) => {
  const { remote, remoteLoading, sendCommand } = useCitrusView();
  const buttons = remote?.buttons ?? [];
  const classes = useStyles();

  if (open === false) return null;

  const getButton = (buttonName: string) =>
    buttons.find(
      (button) => button.name.toUpperCase() === buttonName.toUpperCase()
    );

  const handlePress = (buttonName: string) => {
    const button = getButton(buttonName);
    if (button !== undefined) sendCommand(button.id);
  };

  return (
    <Draggable defaultClassName="z-[9999] shadow-2xl" bounds="parent">
      <div className="absolute bottom-[4px] right-[70px] pt-6 pb-4 w-[220px] px-4 gap-2 rounded grid grid-cols-3 bg-black/70 w-full">
        <IconButton
          className="absolute top-0 right-0"
          onClick={onClose}
          onTouchEnd={onClose}
        >
          <Close />
        </IconButton>
        <button
          disabled={Boolean(getButton('BACK')) === false}
          className={classes.textButton}
          onClick={() => handlePress('BACK')}
          onTouchEnd={() => handlePress('BACK')}
        >
          BACK
        </button>
        <button
          disabled={Boolean(getButton('UP')) === false}
          className={classes.button}
          onClick={() => handlePress('UP')}
          onTouchEnd={() => handlePress('UP')}
        >
          <KeyboardArrowUp fontSize="large" />
        </button>
        <button
          disabled={Boolean(getButton('GO INTERACTIVE')) === false}
          className={classes.textButton}
          onClick={() => handlePress('GO INTERACTIVE')}
          onTouchEnd={() => handlePress('GO INTERACTIVE')}
        >
          GO INTER
        </button>
        <button
          disabled={Boolean(getButton('LEFT')) === false}
          className={classes.button}
          onClick={() => handlePress('LEFT')}
          onTouchEnd={() => handlePress('LEFT')}
        >
          <NavigateBefore fontSize="large" />
        </button>
        <button
          disabled={Boolean(getButton('OK')) === false}
          className={classes.button}
          onClick={() => handlePress('OK')}
          onTouchEnd={() => handlePress('OK')}
        >
          OK
        </button>
        <button
          disabled={Boolean(getButton('RIGHT')) === false}
          className={classes.button}
          onClick={() => handlePress('RIGHT')}
          onTouchEnd={() => handlePress('RIGHT')}
        >
          <NavigateNext fontSize="large" />
        </button>
        <button
          disabled={Boolean(getButton('EXIT TO')) === false}
          className={classes.textButton}
          onClick={() => handlePress('EXIT TO')}
          onTouchEnd={() => handlePress('EXIT TO')}
        >
          EXIT TO
        </button>
        <button
          disabled={Boolean(getButton('DOWN')) === false}
          className={classes.button}
          onClick={() => handlePress('DOWN')}
          onTouchEnd={() => handlePress('DOWN')}
        >
          <KeyboardArrowDown fontSize="large" />
        </button>
        <button
          disabled={Boolean(getButton('INFO')) === false}
          className={classes.textButton}
          onClick={() => handlePress('INFO')}
          onTouchEnd={() => handlePress('INFO')}
        >
          INFO
        </button>
        <button
          disabled={Boolean(getButton('GUIDE')) === false}
          onClick={() => handlePress('GUIDE')}
          onTouchEnd={() => handlePress('GUIDE')}
          className={clsx(
            classes.button,
            '!w-full col-span-full !text-lg !py-2 !h-fit mt-2'
          )}
        >
          GUIDE
        </button>
      </div>
    </Draggable>
  );
};

const useStyles = () => ({
  button:
    'pointer-events-auto rounded-full border border-border-white h-14 w-14 text-2xl flex items-center justify-center focus:bg-white/20 active:bg-white/20 disabled:opacity-20',
  textButton:
    'bg-transparent text-xs active:text-white/20 focus:bg-white/20 active:bg-white/20 rounded-full px-2 py-1 disabled:opacity-20',
});
